import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 rounded-t-3xl mx-3 md:mx-5 mt-14 md:mt-20">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-heading text-background-50 font-light">订阅更新</h3>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              第一时间获取最新漫画更新通知和独家福利，不错过任何精彩内容。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="输入您的邮箱"
                className="flex-1 h-11 px-4 bg-transparent border-b border-foreground-600 text-sm text-background-50 placeholder-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button className="whitespace-nowrap px-6 h-11 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 transition-colors flex items-center gap-2 cursor-pointer">
                订阅 <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-medium text-background-50 mb-5">快速导航</h4>
            <div className="space-y-3">
              <Link to="/" className="block text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">首页</Link>
              <Link to="/category/hot-blood" className="block text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">热门漫画</Link>
              <Link to="/category/fantasy" className="block text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">最新上架</Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-9">
            <h4 className="text-sm font-medium text-background-50 mb-5">联系我们</h4>
            <div className="space-y-2 text-sm text-foreground-400">
              <p>电话：400-888-5151</p>
              <p>邮箱：contact@51comic.com</p>
            </div>
            <h4 className="text-sm font-medium text-background-50 mt-8 mb-3">地址</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              北京市朝阳区望京SOHO<br />T1座12层1206室
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap" rel="nofollow">微博</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap" rel="nofollow">微信</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap" rel="nofollow">B站</a>
          </div>
          <p className="text-sm text-foreground-500 whitespace-nowrap">
            &copy; 2026 51漫画 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}